module.exports = __webpack_public_path__ + "media/images/sebastiao_nervoso-bc8c37eac8647e162205f9748943d21f.png";